import type { FlashCardUI } from "../models/FlashcardUI";

/** First-open index: last list position marked completed, else first incomplete (or 0 if all complete). */
export function resolveInitialFlashcardIndex(mapped: FlashCardUI[]): number {
  if (mapped.length === 0) {
    return 0;
  }
  for (let i = mapped.length - 1; i >= 0; i--) {
    if (mapped[i].isCompleted) {
      return i;
    }
  }
  const firstIncomplete = mapped.findIndex((c) => !c.isCompleted);
  return firstIncomplete === -1 ? 0 : firstIncomplete;
}
